import { Suspense, lazy } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import WhatsAppButton from "@/components/WhatsAppButton";

// Lazy load components below the fold
const Solutions = lazy(() => import("@/components/Solutions"));
const Process = lazy(() => import("@/components/Process"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Comparison = lazy(() => import("@/components/Comparison"));
const FAQ = lazy(() => import("@/components/FAQ"));
const NewContact = lazy(() => import("@/components/NewContact"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => (
  <div className="min-h-screen overflow-x-clip bg-paper">
    <Header />
    <main>
      <Hero />
      <Problem />
      <Suspense fallback={<div className="min-h-screen" />}>
        <Solutions />
        <Process />
        <Testimonials />
        <Comparison />
        <FAQ />
        <NewContact />
      </Suspense>
    </main>
    <Suspense fallback={null}>
      <Footer />
    </Suspense>
    <WhatsAppButton />
  </div>
);

export default Index;
